/**
 * Column header menu — exactly two actions (R6.5): Clear values, Remove column.
 */
import { Menu, MenuItem } from '@vibe/core';
import { CloseSmall, Delete } from '@vibe/icons';
import React from 'react';
import AnchoredPopover from './AnchoredPopover';

export default function ColumnMenu({ anchorEl, column, onClearValues, onRemoveColumn, onClose }) {
  return (
    <AnchoredPopover anchorEl={anchorEl} onClose={onClose} width={230}>
      <Menu size="medium">
        <MenuItem
          icon={CloseSmall}
          title="Clear values"
          onClick={() => {
            onClearValues(column);
            onClose();
          }}
        />
        <MenuItem
          icon={Delete}
          title="Remove column"
          onClick={() => {
            onRemoveColumn(column);
            onClose();
          }}
        />
      </Menu>
    </AnchoredPopover>
  );
}
